import axiosInstance from './axios.service';

/** Backend may return a bare array or `{ faqs }` / `{ data }` / etc. */
function normalizeFaqList(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw.faqs)) return raw.faqs;
  if (Array.isArray(raw.data)) return raw.data;
  if (Array.isArray(raw.questions)) return raw.questions;
  return [];
}

const faqService = {
  getFaqs: async () => {
    const { data } = await axiosInstance.get('/api/faqs/published');
    return normalizeFaqList(data);
  },

  createFaq: async faqData => {
    const { data } = await axiosInstance.post('/api/faqs', faqData);
    return data;
  },

  updateFaq: async (id, faqData) => {
    const { data } = await axiosInstance.put(`/api/faqs/${id}`, faqData);
    return data;
  },

  deleteFaq: async id => {
    const { data } = await axiosInstance.delete(`/api/faqs/${id}`);
    return data;
  },
};

export default faqService;
